import React, { useEffect, useState } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { Step } from '../types';

import { BackButton } from './buttons/back-button';
import { ExtraButton } from './buttons/extra-button';
import { NextButton } from './buttons/next-button';
import { SubmitButton } from './buttons/submit-button';
import {
	FooterButtonsWrapper,
	FooterInfoTextWrapper,
	FooterWrapper,
	HorizontalDivider,
} from './styled';

interface OwnProps {
	currentStepConfig: Step;
	testId: string;
	contentSize: string;
	currentStep: number;
}

export const Footer = ({ currentStepConfig, testId, contentSize, currentStep }: OwnProps) => {
	const {
		formId,
		nextButtonOnClick,
		extraButtonOnClick,
		footerInfoText,
		backButtonOnClick,
		isSubmissionLoading,
		backButtonText,
		backButtonAppearance,
		extraButtonText,
		extraButtonAppearance,
		isExtraButtonDisabled,
		nextButtonText,
		nextButtonAppearance,
		isNextButtonDisabled,
	} = currentStepConfig;

	const [previousStep, setPreviousStep] = useState<number>(currentStep);
	const [isFooterInfoTextUpdated, setIsFooterInfoTextUpdated] = useState<boolean>(false);

	useEffect(() => {
		if (currentStep !== previousStep) {
			setIsFooterInfoTextUpdated(false);
		} else {
			setIsFooterInfoTextUpdated(true);
		}
		setPreviousStep(currentStep);
	}, [currentStep, previousStep]);

	return (
		<>
			<HorizontalDivider data-testid={`${testId}-footer-divider`} role="presentation" />
			<FooterWrapper data-testid={`${testId}-footer`} contentSize={contentSize}>
				<FooterInfoTextWrapper
					data-testid={`${testId}-footer-info-text`}
					role={isFooterInfoTextUpdated ? 'status' : undefined}
					aria-atomic={isFooterInfoTextUpdated ? 'true' : undefined}
				>
					{footerInfoText}
				</FooterInfoTextWrapper>
				<FooterButtonsWrapper>
					{backButtonOnClick && (
						<BackButton
							backButtonOnClick={backButtonOnClick}
							isSubmissionLoading={isSubmissionLoading}
							backButtonText={backButtonText}
							backButtonAppearance={backButtonAppearance}
							testId={testId}
						/>
					)}

					{extraButtonOnClick && (
						<ExtraButton
							extraButtonText={extraButtonText}
							extraButtonOnClick={extraButtonOnClick}
							extraButtonAppearance={extraButtonAppearance}
							isExtraButtonDisabled={isExtraButtonDisabled}
							isSubmissionLoading={isSubmissionLoading}
							testId={testId}
						/>
					)}

					{/* Duplicating the Next Button to avoid sharing props between a submit and button type. An error occurs when a button type precedes a submit type.
                The button type, when clicked, triggers the submit event of the form linked to the submit type. */}
					{!!nextButtonOnClick && !formId && (
						<NextButton
							nextButtonText={nextButtonText}
							nextButtonOnClick={nextButtonOnClick}
							nextButtonAppearance={nextButtonAppearance}
							isNextButtonDisabled={isNextButtonDisabled}
							isSubmissionLoading={isSubmissionLoading}
							testId={testId}
						/>
					)}

					{!!formId && (
						<SubmitButton
							nextButtonText={nextButtonText}
							nextButtonOnClick={nextButtonOnClick}
							nextButtonAppearance={nextButtonAppearance}
							isNextButtonDisabled={isNextButtonDisabled}
							isSubmissionLoading={isSubmissionLoading}
							formId={formId}
							testId={testId}
						/>
					)}
				</FooterButtonsWrapper>
			</FooterWrapper>
		</>
	);
};
